import { useEffect } from "react";

const usePreventScroll = (isScrollable: boolean): void => {
  useEffect(() => {
    const handleScroll = (event: Event): void => {
      if (isScrollable) {
        event.preventDefault();
      }
    };

    if (isScrollable) {
      document.body.style.overflow = "hidden";
      document.addEventListener("scroll", handleScroll, { passive: false });
    } else {
      document.body.style.overflow = "auto";
      document.removeEventListener("scroll", handleScroll);
    }

    return () => {
      document.body.style.overflow = "auto";
      document.removeEventListener("scroll", handleScroll);
    };
  }, [isScrollable]);
};

export default usePreventScroll;
